import {Hint} from 'components/Hint';
import style from './style.module.scss';

interface ISelectTooltipOptionProps {
    content: string;
    hintText: string;
    hintPosition: 'top-right' | 'top-left' | 'bottom-left' | 'bottom-right';
}

export const SelectTooltipOption = (props: ISelectTooltipOptionProps) => {
    const {content, hintText, hintPosition} = props;

    return (
        <div className={style.main}>
            <span>{content}</span>
            <Hint
                classNames={{tooltip: style.tooltip, tooltipContent: style.tooltipContent}}
                className={style.hint}
                text={hintText}
                position={hintPosition}
            />
        </div>
    );
};
